import orderBy from "lodash/orderBy"
import { LCategory } from "@lib/abpUtility"

const ACTION_SUFFIXES = [
  ".Create",
  ".Read",
  ".Update",
  ".Delete",
  ".Detail",
  ".Import",
  ".Export",
  ".Print",
  ".ViewFull",
  ".CreateOrUpdate",
  ".ViewAll",
  ".Approval",
  ".CreateAndUpdate",
] as const

function isActionPermission(name: string): boolean {
  return ACTION_SUFFIXES.some((suffix) => name.endsWith(suffix))
}

export type NormalizedPermission<T extends { name: string }> = T & {
  displayName: string
  parentName?: string
  order: number
}

/**
 * Localizes permission labels via WebCategory and derives parentName from dotted
 * permission keys — same rules as roleService.getAllPermissions().
 */
export function normalizePermissionList<T extends { name: string; displayName?: string }>(
  items: T[]
): NormalizedPermission<T>[] {
  const permissions = items.map((item) => {
    const order = isActionPermission(item.name) ? 1 : 2
    let displayName = LCategory(item.name)
    let parentName: string | undefined

    const paths = (item.name || "").split(".")
    if (paths.length > 1) {
      if (order === 1) {
        displayName = LCategory(paths[paths.length - 1])
      }
      paths.pop()
      parentName = paths.join(".")
    }

    return {
      ...item,
      displayName,
      parentName,
      order,
    }
  })

  return orderBy(permissions, ["name", "order"])
}
